/** Max "unread reviews" space rows shown in the recommended ItemGroup. */
export const MAX_UNREAD_REVIEW_SPACES = 3;

/**
 * How many of the host's spaces to fetch reviews for on initial load. Full
 * scroll-based lazy pagination across all spaces is a separate follow-up; this
 * caps the per-space review calls for hosts with large portfolios.
 */
export const UNREAD_REVIEW_SPACES_BATCH_SIZE = 10;

/** Square pixel size (1x) requested for the space thumbnail on a row. */
export const UNREAD_REVIEW_THUMBNAIL_PX = 80;

/**
 * How many message threads to scan when deriving the host's space ids as a
 * fallback (used only until the owner `reviews-last-viewed` endpoint ships).
 */
export const HOST_SPACES_MESSAGE_LOOKUP_SIZE = 50;
